/**
 * Pure decision: can the learner reset their own course progress?
 *
 * Requires the course to have learner-self-reset enabled, the user to be a
 * returning learner, and (when a max-resets cap is configured) for them to
 * have remaining resets.
 */
export interface LearnerResetInput {
  courseData: {
    learnerResetEnabled?: boolean;
    maxLearnerResets?: number | null;
    learnerResetCount?: number | null;
  } | null | undefined;
  isReturningLearner: boolean;
}

export function canLearnerSelfReset(input: LearnerResetInput): boolean {
  const course = input.courseData;
  if (!course || !course.learnerResetEnabled) return false;
  if (!input.isReturningLearner) return false;

  const max = course.maxLearnerResets;
  const used = course.learnerResetCount || 0;
  if (max !== null && max !== undefined && used >= max) return false;

  return true;
}
